/** 拖动排序（原生 HTML5 拖放）+ 上 / 下移按钮兜底（键盘 / 触屏也能排）——手机站精选 / 横幅 / 同行站清单共用。 */
import { useRef } from "react";

export function useReorder<T>(items: T[], setItems: (v: T[]) => void) {
  const dragFrom = useRef<number | null>(null);
  const move = (from: number, to: number) => {
    if (to < 0 || to >= items.length || from === to) return;
    const next = items.slice();
    const [it] = next.splice(from, 1);
    next.splice(to, 0, it);
    setItems(next);
  };
  const dragProps = (i: number) => ({
    draggable: true,
    onDragStart: () => { dragFrom.current = i; },
    onDragOver: (e: React.DragEvent) => e.preventDefault(),
    onDrop: (e: React.DragEvent) => { e.preventDefault(); if (dragFrom.current != null) move(dragFrom.current, i); dragFrom.current = null; },
  });
  return { move, dragProps };
}
